import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcUnfoldRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9688 6.52083H12.5875V7.85417H14.9688V6.52083Z",
			fill: "#212329"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5875 9.33333H14.9688V10.6667L12.5875 10.6667V9.33333Z",
			fill: "#212329"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9688 12.1458H12.5875V13.4792H14.9688V12.1458Z",
			fill: "#212329"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5 2.96875C3.61929 2.96875 2.5 4.08804 2.5 5.46875V14.5312C2.5 15.912 3.61929 17.0312 5 17.0312H15C16.3807 17.0312 17.5 15.912 17.5 14.5312V5.46875C17.5 4.08804 16.3807 2.96875 15 2.96875H5ZM15 4.46875H11.6875V15.5312H15C15.5523 15.5312 16 15.0835 16 14.5312V5.46875C16 4.91647 15.5523 4.46875 15 4.46875ZM5 15.5312H10.1875V4.46875H5C4.44772 4.46875 4 4.91647 4 5.46875V14.5312C4 15.0835 4.44772 15.5312 5 15.5312Z",
			fill: "#212329"
		})
	]
});
export default SvgIcUnfoldRight;
